// extracted by mini-css-extract-plugin
export var Transition = "Transition-module--Transition--o0kYa";